import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ChartModule } from '@syncfusion/ej2-angular-charts';
import { CategoryService, LegendService, DataLabelService, LineSeriesService } from '@syncfusion/ej2-angular-charts';

import { CoreModule } from '../core/core.module';
import { LiftComponent } from './containers/lift/lift.component';
import { LiftModuleComponent } from './containers/lift-module/lift-module.component';
import { LiftModuleDetailComponent } from './containers/lift-module-detail/lift-module-detail.component';
import { LiftDetailComponent } from './containers/lift-detail/lift-detail.component';
import { CreateLiftModuleComponent } from './containers/create-lift-module/create-lift-module.component';
import { CreateLiftComponent } from './containers/create-lift/create-lift.component';
import { LiftStateComponent } from './containers/lift-state/lift-state.component';
import { LiftErrorComponent } from './containers/lift-error/lift-error.component';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { LiftFormComponent } from './forms/lift-form/lift-form.component';
import { ModuleFilterComponent } from './components/module-filter/module-filter.component';
import { LiftFilterComponent } from './components/lift-filter/lift-filter.component';
import { TranslateModule } from '@ngx-translate/core';
import { LiftRideComponent } from './containers/lift-ride/lift-ride.component';
import { LiftConsumptionComponent } from './containers/lift-consumption/lift-consumption.component';
import { LiftParametersComponent } from './containers/lift-parameters/lift-parameters.component';
import { LiftDetailMenuComponent } from './components/lift-detail-menu/lift-detail-menu.component';
import { LiftUserComponent } from './containers/lift-user/lift-user.component';
import { LiftTemperatureComponent } from './containers/lift-temperature/lift-temperature.component';
import { LiftParameterSettingsComponent } from './containers/lift-parameter-settings/lift-parameter-settings.component';
import { LiftParameterFilterComponent } from './components/lift-parameter-filter/lift-parameter-filter.component';
import { LiftParameterSettingsDetailComponent } from './containers/lift-parameter-settings-detail/lift-parameter-settings-detail.component';
import { CreateLiftParameterSettingsComponent } from './containers/create-lift-parameter-settings/create-lift-parameter-settings.component';
import { LiftBoardParameterComponent } from './containers/lift-board-parameter/lift-board-parameter.component';
import { LiftBoardParameterDetailComponent } from './containers/lift-board-parameter-detail/lift-board-parameter-detail.component';
import { LiftBoardParameterGroupDetailComponent } from './containers/lift-board-parameter-group-detail/lift-board-parameter-group-detail.component';
import { CreateLiftBoardParameterGroupComponent } from './containers/create-lift-board-parameter-group/create-lift-board-parameter-group.component';
import { CreateLiftBoardParameterComponent } from './containers/create-lift-board-parameter/create-lift-board-parameter.component';
import { BrowserModule } from '@angular/platform-browser';
import { LiftControllerComponent } from './containers/lift-controller/lift-controller.component';
import { TreeModule } from 'angular-tree-component';

@NgModule({
  declarations: [
    LiftComponent,
    LiftModuleComponent,
    LiftModuleDetailComponent,
    LiftDetailComponent,
    CreateLiftModuleComponent,
    CreateLiftComponent,
    LiftStateComponent,
    LiftErrorComponent,
    LiftFormComponent,
    ModuleFilterComponent,
    LiftFilterComponent,
    LiftRideComponent,
    LiftConsumptionComponent,
    LiftParametersComponent,
    LiftDetailMenuComponent,
    LiftUserComponent,
    LiftTemperatureComponent,
    LiftParameterSettingsComponent,
    LiftParameterFilterComponent,
    LiftParameterSettingsDetailComponent,
    CreateLiftParameterSettingsComponent,
    LiftBoardParameterComponent,
    LiftBoardParameterDetailComponent,
    LiftBoardParameterGroupDetailComponent,
    CreateLiftBoardParameterGroupComponent,
    CreateLiftBoardParameterComponent,
    LiftControllerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    NgbTypeaheadModule,
    TranslateModule,
    DatePickerModule,
    ChartModule,
    TreeModule
  ],
  providers: [CategoryService, LegendService, DataLabelService, LineSeriesService],
  exports: []
})
export class LiftModule { }
